import BaseComponent from '@components/base-component';
import OptionItem from '@components/options-list/option/option';
import Controls from '@components/options-list/options-controls/options-controls';
import PasteList from '@components/pasteOption/paste-list';
import tag from '@components/utility-components';
import * as styles from './options-list.module.scss';
export default class OptionsList extends BaseComponent {
    machine;
    showMessage;
    list;
    lastId = 1;
    constructor(machine, modalControls, linkHandler, showMessage) {
        super({ elementTag: 'div', classes: [styles.mainBlock] });
        this.machine = machine;
        this.showMessage = showMessage;
        this.list = tag.ul({ classes: [styles.list] });
        const pasteList = new PasteList(modalControls, this.appendPasteList.bind(this));
        const controlsCallbacks = {
            add: () => this.appendOption.bind(this)(),
            paste: () => modalControls.showModal(pasteList.createTextarea()),
            clear: this.clearOptionsList.bind(this),
            start: linkHandler,
        };
        const controls = new Controls(this.machine, controlsCallbacks);
        this.appendChildren(this.list, controls);
        this.addListeners();
    }
    addListeners() {
        this.addListener('click', this.handleDeleteClick.bind(this));
        this.addListener('change', this.handleInputsChange.bind(this));
        this.machine.on(this.machine.events.machineStateChanged, this.handleStateChange.bind(this));
    }
    handleStateChange(payload) {
        const { trigger } = payload;
        if (trigger === 'navigateOptionsList' || trigger === 'fileLoaded') {
            this.rerenderList();
        }
        if (trigger === 'invalidFile') {
            this.showMessage('invalidFile');
        }
    }
    rerenderList() {
        const { options, lastId } = this.machine.context;
        this.list.removeChildren();
        this.lastId = lastId;
        for (const option of options) {
            const optionItem = new OptionItem(option);
            this.list.appendSingle(optionItem);
        }
        setTimeout(() => {
            this.fixOptionsIdColumn(this.list.childComponents.at(-1));
        }, 0);
    }
    fixOptionsIdColumn(listLastChild) {
        if (listLastChild instanceof OptionItem) {
            for (const option of this.list.childComponents) {
                const width = listLastChild.label.getElement().offsetWidth;
                if (option instanceof OptionItem) {
                    const optionWidth = option.label.getElement().offsetWidth;
                    if (optionWidth !== width)
                        option.label.getElement().style.minWidth = `${width}px`;
                }
            }
        }
    }
    appendOption(partialOption) {
        if (this.list.childComponents.length === 0)
            this.lastId = 0;
        const id = ++this.lastId;
        const option = partialOption ? { id, ...partialOption } : { id, title: '', weight: 0 };
        const optionItem = new OptionItem(option);
        this.list.appendSingle(optionItem);
        this.fixOptionsIdColumn(optionItem);
        const { options } = this.machine.context;
        options.push(option);
        this.machine.makeTransition(this.machine.value, 'addOption', {
            options: [...options],
            lastId: this.lastId,
        });
    }
    appendPasteList(partialOptions) {
        for (const partialOption of partialOptions) {
            setTimeout(() => {
                this.appendOption(partialOption);
            }, 0);
        }
    }
    handleInputsChange(event) {
        const input = event.target;
        if (input instanceof HTMLInputElement) {
            const { options } = this.machine.context;
            const id = Number.parseInt(input.id.slice(1));
            const currentOption = options.find((option) => option.id === id);
            if (currentOption) {
                const property = input.name;
                const { value } = input;
                if (property === 'title')
                    currentOption[property] = value;
                else if (property === 'weight')
                    currentOption[property] = Number(value);
                this.machine.makeTransition(this.machine.value, 'modifyOption', { options: [...options] });
            }
        }
    }
    handleDeleteClick(event) {
        const deleteButton = event.target;
        if (deleteButton instanceof HTMLButtonElement && deleteButton.name === 'delete option') {
            const id = Number.parseInt(deleteButton.id.slice(1));
            const optionToRemove = this.list.childComponents.find((child) => {
                const childId = child.getElement().getAttribute('id');
                if (!childId)
                    return false;
                return id === Number.parseInt(childId?.slice(1));
            });
            optionToRemove?.removeSelf();
            const { options } = this.machine.context;
            const filteredOptions = options.filter((option) => option.id !== Number(id));
            if (this.list.childComponents.length > 0) {
                this.machine.makeTransition(this.machine.value, 'removeOption', {
                    options: [...filteredOptions],
                });
            }
            else {
                this.clearOptionsList();
            }
        }
    }
    clearOptionsList() {
        this.list.removeChildren();
        this.machine.makeTransition(this.machine.value, 'clearList', { options: [], lastId: 0 });
    }
}
